import { render } from "./Landing.vue?vue&type=template&id=6c251230"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"

import exportComponent from "C:\\AutomotiveAgent\\SalesSaaS\\frontend\\salessaaschat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__